import React from "react";

var randomImage = [];

for (let i = 0; i < 10; i++) {
  const h = Math.round(Math.random() * (600 - 400) + 400);
  const a = [
    "Mike",
    "Nick",
    "Slagathor",
    "Banana",
    "Rick",
    "Astley",
    "Rock",
    "JW",
    "pronax",
    "Chris",
  ];
  randomImage[i] = {};
  randomImage[i].image = `https://placekitten.com/${h}/${h}`;
  randomImage[i].name = a[i];
}

const Featured = () => {
  return (
    <div className="card_wrapper">
      {randomImage.map((el, i) => (
        <div
          key={i}
          style={{ borderColor: `#${Math.random().toString(16).slice(2, 8)}` }}
          className="rounded-circle image_outer"
        >
          <img src={el.image} alt={el.name} className="w-100" />
          <div className="name_person">{el.name}</div>
        </div>
      ))}
    </div>
  );
};

export default Featured;
